export const config = {
  api_host: 'https://api.ped-em-care.com',
  api_url: 'https://api.ped-em-care.com/api',
}